<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">
  <form #resizeImageForm="ngForm">
  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Resize Image</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">

        <div class="upload-box" (click)="fileUploadRef.click()" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>Click to Add or Drag & Drop Image</p>

          <input type="file" id="fileUpload" (change)="onSelect($event)" [accept]="allowedExtensions.join(',')"
            required ngModel #fileInput="ngModel" class="hidden"
            name="fileUpload" id="fileUpload" #fileUploadRef />
          <!-- <label for="fileUpload">Choose File</label> -->
        </div>
        @if (resizeImageRequestModel.image) {
        <div class="file-info cursor-pointer" (click)="clear()">
          <span class="file-name">{{ resizeImageRequestModel.image.name }}</span>
          <span class="clear-button">✖</span>
        </div>
        }
        @if(fileError){
        <div class="text-red-500 text-sm mt-2">{{this.fileError}}</div>
        }

    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full lg:w-auto lg:flex-1 lg:min-w-0 min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Original
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Resized-Image'}" (click)="setTab('Resized-Image')">
                  Resized Image
              </a>
          </li>
          @if (resizeImageRequestModel.image) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>
        @if(isLoading){
        <div class="rounded-2xl">
          <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
        </div>
        }
        @else {
        @if(!resizeImageRequestModel.image){
        <div class="image-preview">
          <p>No image uploaded yet</p>
        </div>
        }
        @else {
          @if(activeTab === 'Original'){
            <div class="image-preview">
              <img [src]="this.imageUrl" alt="Uploaded" />
            </div>
          }
          @else {
            @if(isLoading) {
              <div class="h-[400px] w-full bg-gray-200 rounded animate-pulse"></div>
             }
             @else if(!resizeImageResponseModel.base64_image){
              <div class="image-preview">
                <p>No image uploaded yet</p>
              </div>
              }
             @else if(resizeImageResponseModel.base64_image){
               <div class="image-preview">
                 <img [src]="getImageSource" alt="Removed Background" />
               </div>
             }
          }
        }
        }

      </div>

      <div class="w-full lg:w-80 shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white">
        <div class="flex gap-2 w-full">
          <div class="mb-1 flex-1 min-w-0">
            <label for="target_width" class="block mb-1 text-sm font-medium">Width</label>
            <input  type="number"  required name="target_width" #target_width="ngModel" id="target_width"
              [(ngModel)]="resizeImageRequestModel.target_width"
              [min]="1"
              [max]="9999"
              class="border border-gray-300 rounded-md px-3 py-2 w-full min-w-0" />
            <app-form-validator [control]="target_width" [fieldName]="'Width'"></app-form-validator>
          </div>
          <div class="mb-1 flex-1 min-w-0">
            <label for="target_height" class="block mb-1 text-sm font-medium">Height</label>
            <input  type="number"  required name="target_height" #target_height="ngModel" id="target_height"
              [(ngModel)]="resizeImageRequestModel.target_height"
              [min]="1"
              [max]="9999"
              class="border border-gray-300 rounded-md px-3 py-2 w-full min-w-0" />
            <app-form-validator [control]="target_height" [fieldName]="'Height'"></app-form-validator>
          </div>
        </div>
        <div class="mb-1">
          <label for="maintain_aspectratio" class="block mb-1 text-sm font-medium">
            <input
              type="checkbox"
              id="maintain_aspectratio"
              name="maintain_aspectratio"
              [(ngModel)]="resizeImageRequestModel.maintain_aspectratio"
              #maintain_aspectratio="ngModel"
              class="w-4 h-4 accent-black"

            />
            Maintain Aspect Ratio
          </label>
        </div>
        <div class="mb-1">

         <button type="submit" (click)="resizeImage()" [disabled]="!resizeImageForm.valid"
         class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5 text-white font-medium bg-black">
            Resize Image
            @if(isLoading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
         </button>
        </div>
        @if (resizeImageResponseModel.base64_image) {
          <div class="mb-1">
          <button type="submit" (click)="downloadImage()" [disabled]="!resizeImageRequestModel.image && resizeImageRequestModel.target_width===0 && resizeImageRequestModel.target_height===0"
            class="flex items-center justify-center py-3 w-full rounded-full text-base leading-5
             text-white font-medium bg-black">
             Download Image
            @if(isDownloading){
            <span
              class="border-white h-4 w-4 animate-spin rounded-full border-2 border-t-white ms-2"></span>
            }
          </button>
          </div>
        }
      </div>
    </div>

  </div>

</form>
</div>
